module.exports = __webpack_public_path__ + "img/login-img1.38d51e51.png";